import 'date-fns';
import React, { useState, useEffect } from 'react';
import { Pie, Line, Bar, HorizontalBar,} from 'react-chartjs-2';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

const PrecioDynamicGraph = (props) => {
  
  let type = props.data.data.find(element => element.name === "Precios_Stats")
  console.log("PrecioDynamicGraph", type);
  const [selectedDateInicial, setSelectedDateInicial] = React.useState(null);
  const [selectedDateFinal, setSelectedDateFinal] = React.useState(null);
  const [label, setLabel] = React.useState();
  let labelsCopy =[]

  const labelsModifier = (x) => {
    labelsCopy = label;
    if(x === 1) {
      let index = labelsCopy.indexOf(selectedDateInicial)
      console.log(index)
      setLabel(labelsCopy.slice(index, labelsCopy.length - 1))
    } else {
      let index = labelsCopy.indexOf(selectedDateFinal)
      console.log(index)
      setLabel(labelsCopy.slice(0, index))
    }
    console.log("sdffsdfs",label)
  }

  const handleDateChangeInicial = date => {
    setSelectedDateInicial(date);
    labelsModifier(1)
  };

  const handleDateChangeFinal = date => {
    setSelectedDateFinal(date);
    // let labelsCopy = labels
    labelsModifier(2)
  };


  let labelArray = [];
  // let minimo = null;
  // let maximo = null;
  let dataArray = [];
  let dataArray2 = [];
  let dataArray3 = [];
  let price_new = null;
  let price_list = [];
  let mapData = null;
  let Conteo = null;
  let mapInfo = {};
  let word = {}
  let data = null; 
  let options = null; 
  let limit = 8
  

  let dataTreatment = () => {    
    for (let x in type.data){
      if(type.data[x].Price_new != null){
        price_list.push(type.data[x].Price_new);
      };
      if(type.data[x].Sentiment !== null){
        labelArray.push(x);
        dataArray.push(type.data[x].Sentiment);
        dataArray2.push(price_list[price_list.length - 1]);
      };
    };
    
    
    
    data = {
      labels: labelArray,
      datasets: [{
        fill: false,
        label: 'Sentimiento',
        yAxisID: 'Sentimiento',
        // lineTension: 0.1,
        // backgroundColor: 'rgba(75,192,192)',
        borderColor: '#C72544',
        // borderCapStyle: 'butt',
        // borderDash: [],
        // borderDashOffset: 1.0,
        data: dataArray,
        hoverBackgroundColor: [
          '#C72544',
          // '#DF668F',
          // '#F4CCDA'
        ]
      },
      {
        fill: false,
        steppedLine: true,
        label: 'Precio',
        yAxisID: 'Precio',
        // lineTension: 0.1,
        // backgroundColor: 'rgba(75,192,192)',
        borderColor: '#3DBAB3',
        // borderCapStyle: 'butt',
        // borderDash: [],
        // borderDashOffset: 1.0,
        data: dataArray2,
        hoverBackgroundColor: [
          // '#3DBAB3',
          // '#DF668F',
          '#3DBAB3'
        ]
      }]
    };
    
    options = {
      maintainAspectRatio: false,
      responsive: true,
      borderSkipped: true,
      legend: {
        display:true,
        labels: {
          fontSize: 10
        }
      },
      scales: {
        xAxes: [{
          // type: "time",
          ticks: {
            fontSize: 9
          },
          scaleLabel: {
            display: true,
            labelString: 'Fecha'
          }
        }],
        yAxes: [{
          id: 'Sentimiento',
          type: 'linear',
          position: 'left',
          ticks: {
            fontSize: 9,
            max: Math.max.apply(Math, dataArray),
            min: Math.min.apply(Math, dataArray),
          },
          scaleLabel: {
            display: true,
            labelString: 'Sentimiento promedio'
          }
        },
        {
          id: 'Precio',
          type: 'linear',
          position: 'right',
          ticks: {
            fontSize: 11,
            max: Math.max.apply(Math, price_list),
            min: Math.min.apply(Math, price_list),
          },
          scaleLabel: {
            display: true,
            labelString: 'Precio promedio'
          }
        }]
      }
    }
    
    return (
      <div style={{width: "70%"}}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container justify="space-around">
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="yyyy/MM/dd"
              minDate={labelArray[0]}
              maxDate={labelArray[labelArray.length -1]}
              disableFuture
              margin="normal"
              id="date-picker-inline"
              label="Date picker inline"
              value={selectedDateInicial}
              onChange={handleDateChangeInicial}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="yyyy/MM/dd"
              minDate={labelArray[0]}
              maxDate={labelArray[labelArray.length -1]}
              margin="normal"
              id="date-picker-inline"
              label="Date picker inline"
              value={selectedDateFinal}
              onChange={handleDateChangeFinal}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </Grid>
        </MuiPickersUtilsProvider>
        <Line data={data} options={options} />
      </div>
    )
  }

  useEffect(() => {
    dataTreatment()
    setLabel(labelArray)
    setSelectedDateInicial(labelArray[0])
    setSelectedDateFinal(labelArray[labelArray.length - 1])

  }, [])

  return(
    <div>
      { dataTreatment() }
    </div>
  )
};

export default PrecioDynamicGraph;